import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { BookCover } from "../components/Bits";

export const SLOGAN = "You write. We find the readers.";

export default function SignIn() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  useEffect(() => {
    if (user) navigate("/dashboard", { replace: true });
  }, [user, navigate]);
  useEffect(() => {
    const prev = document.title;
    document.title = `Join AuthorOS — ${SLOGAN}`;
    return () => {
      document.title = prev;
    };
  }, []);
  return (
    <div className="max-w-5xl mx-auto px-6 lg:px-10 py-20 grid md:grid-cols-12 gap-14 items-center" data-testid="signin-page">
      <div className="md:col-span-7 rise">
        <h1 className="font-display text-5xl sm:text-6xl tracking-tight" data-testid="signin-title">Join <span className="scribble italic">AuthorOS</span></h1>
        <p className="font-display italic text-2xl text-[#5C584E] mt-6" data-testid="signin-slogan">{SLOGAN}</p>
        <p className="label-mono mt-8">Free while we're in beta.</p>
        <button className="btn-primary mt-6" onClick={login} data-testid="signin-google-button">Continue with Google</button>
      </div>
      <div className="md:col-span-5 relative h-72 sm:h-80 hidden sm:block">
        <BookCover src="/samples/cover3.jpg" title="Small Weather" className="absolute w-40 left-4 top-6 -rotate-6" />
        <BookCover title="Your next book" author="You" className="absolute w-44 right-6 top-0 rotate-3 z-10" />
      </div>
    </div>
  );
}
